import React, { useEffect } from "react";
import { Navigate, useNavigate, useParams } from "react-router-dom";
import axios from "axios";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useDispatch, useSelector } from "react-redux";
import { baseURL, getBlog } from "../redux/Action";
import { FiAlertTriangle } from "react-icons/fi";

const ConfirmDelete = () => {
  const { user, blog, token } = useSelector((state) => state);

  const dispatch = useDispatch();
  const { id } = useParams();
  const navigate = useNavigate();
  const notify = () =>
    toast("Moved to Trash", { theme: "dark", type: "success" });
  const error = () => toast.error("Something went wrong");

  useEffect(() => {
    document.title = `Blogshog | Delete Blog`;
    getBlog(dispatch, id);
  }, [dispatch, id]);

  const handleDelete = () => {
    const toastId = toast.loading("Trashing...", { theme: "dark" });
    axios
      .delete(`${baseURL}/blogs/${id}`, {
        withCredentials: true,
        headers: {
          Authorization: token,
        },
      })
      .then((res) => {
        toast.dismiss(toastId);
        notify();
        navigate("/blogs", { replace: true });
      })
      .catch((err) => {
        toast.dismiss(toastId);
        error();
      });
  };

  const handleCancel = () => {
    navigate(`/blogs/${id}`);
  };

  if (blog.length > 0 && blog[0].user.email !== user.user.email) {
    return <Navigate to={`/blogs/${id}`} />;
  }

  return (
    <div
      className="fixed inset-0 z-50 overflow-y-auto"
      aria-labelledby="modal-title"
      role="dialog"
      aria-modal="true"
    >
      {/* Blurred overlay */}
      <div className="fixed inset-0 bg-black/60 dark:bg-black/80 backdrop-blur-sm transition-opacity"></div>

      <div className="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
        <div className="relative transform overflow-hidden bg-white dark:bg-black text-left shadow-[12px_12px_0px_0px_rgba(0,0,0,1)] dark:shadow-[12px_12px_0px_0px_rgba(255,255,255,0.5)] border-4 border-black dark:border-white/30 transition-all sm:my-8 sm:w-full sm:max-w-md">
          <div className="px-6 pt-8 pb-6 sm:p-8 sm:pb-6">
            <div className="sm:flex sm:items-start">
              <div className="mx-auto flex h-14 w-14 flex-shrink-0 items-center justify-center bg-red-100 dark:bg-red-900/30 border-2 border-red-600 dark:border-red-500 sm:mx-0 sm:h-12 sm:w-12">
                <FiAlertTriangle
                  className="h-6 w-6 text-red-600 dark:text-red-500"
                  aria-hidden="true"
                />
              </div>
              <div className="mt-4 text-center sm:ml-4 sm:mt-0 sm:text-left">
                <h3
                  className="text-2xl font-black uppercase tracking-tight text-gray-900 dark:text-white"
                  id="modal-title"
                >
                  Delete Blog Post
                </h3>
                <div className="mt-3">
                  <p className="text-sm font-mono font-bold text-gray-600 dark:text-gray-400 leading-relaxed">
                    Are you sure you want to delete this blog post? It will be
                    moved to the trash and you can restore it later.
                  </p>
                </div>
              </div>
            </div>
          </div>

          <div className="bg-gray-50/80 dark:bg-zinc-900/50 border-t-4 border-black dark:border-white/30 px-6 py-4 sm:flex sm:flex-row-reverse sm:px-8 gap-3">
            <button
              type="button"
              className="inline-flex w-full justify-center bg-red-600 px-6 py-3 text-sm font-black uppercase tracking-wider text-white border-2 border-black dark:border-white/20 hover:-translate-y-1 hover:shadow-[4px_4px_0px_0px_rgba(0,0,0,1)] dark:hover:shadow-[4px_4px_0px_0px_rgba(255,255,255,0.3)] sm:w-auto transition-all duration-200"
              onClick={handleDelete}
            >
              Move to Trash
            </button>
            <button
              type="button"
              className="mt-3 inline-flex w-full justify-center bg-white dark:bg-black px-6 py-3 text-sm font-black uppercase tracking-wider text-gray-900 dark:text-white border-2 border-black dark:border-white/30 hover:-translate-y-1 hover:shadow-[4px_4px_0px_0px_rgba(0,0,0,1)] dark:hover:shadow-[4px_4px_0px_0px_rgba(255,255,255,0.3)] sm:mt-0 sm:w-auto transition-all duration-200"
              onClick={handleCancel}
            >
              Cancel
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ConfirmDelete;
